import { combineReducers } from 'redux';
import activitiesReducer from './activity';
import authReducer from './auth';
import broadcastsReducer from './broadcasts';
import campaignsReducer from './campaigns';
import campaignsPublicReducer from './campaignsPublic';
import contactDetailsReducer from './contactDetails';
import contactsReducer from './contacts';
import crmReducer from './crm';
import customFieldsReducer from './customFields';
import globalReducer from './global';
import meetingsReducer from './meetings';
import messageReducer from './messages';
import officialsReducer from './officials';
import organizationsReducer from './organizations';
import signupsReducer from './signups';
import templatesReducer from './templates';
import virtuousReducer from './virtuous';

const rootReducer = combineReducers({
  activities: activitiesReducer,
  auth: authReducer,
  broadcasts: broadcastsReducer,
  campaigns: campaignsReducer,
  campaignsPublic: campaignsPublicReducer,
  contactDetails: contactDetailsReducer,
  contacts: contactsReducer,
  crm: crmReducer,
  customFields: customFieldsReducer,
  global: globalReducer,
  meetings: meetingsReducer,
  messages: messageReducer,
  officials: officialsReducer,
  organizations: organizationsReducer,
  signups: signupsReducer,
  templates: templatesReducer,
  virtuous: virtuousReducer,
});

export default rootReducer;
